import UrlSelectComponent from '72cms-ui/components/form-elements/UrlSelectComponent';

export default {
    sections: ['details'],
    toolbar: ['add', 'edit', 'active', 'delete'],
    fields: {
        title: {
            section: 'details',
            position: 1,
        },
        link_value: {
            label: 'Link to',
            section: 'details',
            position: 2,
            component: UrlSelectComponent,
            link: ['/pages/_ref_', '/categories/_ref_', '/products/_ref_'],
            disabled: function (value, schema, data) {
                return ['','values'].indexOf(data.panel_type) >= 0;
            },
        },
        link_text: {
            label: 'Link label',
            section: 'details',
            position: 3,
            disabled: function (value, schema, data) {
                return ['banner','values'].indexOf(data.panel_type) >= 0;
            },
        },

        image: {
            section: 'details',
            description: function(value, schema, data) {
                switch (data.panel_type) {
                    case 'banner-grid':
                    return 'Please resize banner images to 380px x 390px prior to uploading.'
                    break;

                    case 'slideshow':
                    return 'Please resize slideshow images to 2000px x 1250px prior to uploading.'
                    break;

                     case 'values':
                    return 'Please resize slideshow images to 950px x 486px prior to uploading.'
                    break;

                }
            },
            position: 4,
            disabled: function (value, schema, data) {
                return ['banner-grid'].indexOf(data.panel_type) >= 0;
            },
        },

        file: {
            section: 'details',
            position: 5,
            disabled: function (value, schema, data) {
                return data.panel_type != 'file-download';
            },
        },

        content: {
            section: 'details',
            position: 6,
            disabled: function (value, schema, data) {
                return ['values'].indexOf(data.panel_type) >= 0;
            },
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.panel_item.js